/**
  * 全局常量、方法封装模块
  * 通过原型挂载到Vue属性
  * 通过 this.Global 调用
  */

// 线上
export let baseUrlImage = "https://interface.honghengxinxi.com/getImg/"   //线上
export let baseUrlImageAdd = "https://interface.honghengxinxi.com" // 图片添加
export let baseUrl = 'https://interface.honghengxinxi.com' //平台
// export let baseUrl = 'http://hongheng.top:9030' //平台
// export let baseUrl = 'http://172.18.110.246:8000' //平台

//  export let baseUrl = 'http://125.69.68.70:8000' //成华平台
//  export let baseUrlImageAdd = "http://125.69.68.70:8000" // 图片添加
//  export let baseUrlImage = "http://125.69.68.70:8000/getImg/"   //线上
// 测试
// export let baseUrl = 'http://192.168.1.8:8000' //平台
// export let baseUrlImageAdd = "http://192.168.1.8:8000" // 图片添加
// export let baseUrlImage = "http://192.168.1.8:8000/getImg/"   //线上
//  export let baserUrlbind='http://192.168.1.112:8088' //智能手环  线下

// ip线上
//  export let baseUrl = 'http://117.78.7.31:8900' //平台
//  export let baseUrlImageAdd = "http://117.78.7.31:8900" // 图片添加
//  export let baseUrlImage = "http://117.78.7.31:8900/getImg/"   //线上v
export let baserUrlbind='https://bracelet.honghengxinxi.com:8088' //智能手环 线上
export let baerUrlAie = 'http://192.168.1.123:9870'
//  开发私有化
if (process.env.NODE_ENV === 'development') {
//   baseUrlImage = "http://192.168.1.8:8000/getImg/"
//   baseUrl="http://192.168.1.8:8000" //本地
//   baseUrlImageAdd = "http://192.168.1.8:8000"
}
export default {
  baseUrl,
  baseUrlImage,
  baseUrlImageAdd,
  baserUrlbind,
  baerUrlAie
}



// WEBPACK FOOTER //
// ./src/utils/global.js